import { render, staticRenderFns } from "./ListPosCustomer.vue?vue&type=template&id=1bfca62a"
import script from "./ListPosCustomer.vue?vue&type=script&lang=js"
export * from "./ListPosCustomer.vue?vue&type=script&lang=js"
import style0 from "./ListPosCustomer.vue?vue&type=style&index=0&id=1bfca62a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports